import React from "react";
import classNames from "classnames";
import "./button.scss";

export interface ButtonProps {
  label?: string;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  variant?: "primary" | "outline";
  children?: React.ReactNode;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
}

export const Button: React.FC<ButtonProps> = ({
  label = "Submit",
  disabled = false,
  onClick,
  className,
  children,
  variant = "primary",
  icon,
  iconPosition = "left",
}) => {
  const buttonClass = classNames("button", `button--${variant}`, { "button--disabled": disabled }, className);

  return (
    <button className={buttonClass} onClick={onClick} disabled={disabled} onTouchStart={(e) => e.preventDefault()}>
      {icon && iconPosition === "left" && <span className="button__icon button__icon--left">{icon}</span>}
      <span>{label ?? children}</span>
      {icon && iconPosition === "right" && <span className="button__icon button__icon--right">{icon}</span>}
    </button>
  );
};
